/**
 * Thumbnail hover → main image swap
 * Champion / Loess theme — targets loess-product-thumbnails
 * Desktop only — mobile keeps tap/click.
 */
(function () {
  var THUMB_SELECTOR =
    'loess-product-thumbnails button[data-media-id], .main-product-media__thumbnails button[data-media-id]';

  function isDesktopHover() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function bindThumbnailHover() {
    if (!isDesktopHover()) return;

    document.querySelectorAll(THUMB_SELECTOR).forEach(function (thumb) {
      if (thumb.dataset.hoverSwapBound === 'true') return;
      thumb.dataset.hoverSwapBound = 'true';

      thumb.addEventListener('mouseenter', function () {
        if (thumb.getAttribute('aria-current') === 'true') return;
        thumb.click();
      });
    });
  }

  function init() {
    bindThumbnailHover();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
/**
 * Lock Loess/Champion product gallery to one size so thumbnails
 * don't cause the page to jump between tall and short images.
 */
(function () {
  var GALLERY_SELECTOR = 'loess-product-gallery.main-product__media-gallery__inner';
  var THUMB_SELECTOR =
    'loess-product-thumbnails button[data-media-id], .main-product-media__thumbnails button[data-media-id]';

  function lockGallerySize(gallery) {
    if (!gallery) return;

    gallery.style.setProperty('aspect-ratio', '1 / 1', 'important');
    gallery.style.setProperty('width', '100%', 'important');
    gallery.style.setProperty('max-width', '100%', 'important');
    gallery.style.setProperty('height', 'auto', 'important');
    gallery.style.setProperty('min-height', '0', 'important');
    gallery.style.setProperty('padding-bottom', '0', 'important');

    gallery.querySelectorAll('.main-product__media-gallery__inner-media').forEach(function (slide) {
      slide.style.setProperty('position', 'absolute', 'important');
      slide.style.setProperty('inset', '0', 'important');
      slide.style.setProperty('width', '100%', 'important');
      slide.style.setProperty('height', '100%', 'important');
      slide.style.setProperty('margin', '0', 'important');
      slide.style.setProperty('padding-bottom', '0', 'important');
    });
  }

  function initGallery(gallery) {
    if (!gallery || gallery.dataset.uniformSizeBound === 'true') return;
    gallery.dataset.uniformSizeBound = 'true';

    lockGallerySize(gallery);

    new MutationObserver(function () {
      lockGallerySize(gallery);
    }).observe(gallery, {
      attributes: true,
      attributeFilter: ['style'],
      subtree: true,
      childList: false
    });

    document.querySelectorAll(THUMB_SELECTOR).forEach(function (thumb) {
      ['click', 'mouseenter'].forEach(function (eventName) {
        thumb.addEventListener(eventName, function () {
          window.requestAnimationFrame(function () {
            lockGallerySize(gallery);
          });
        });
      });
    });
  }

  function init() {
    document.querySelectorAll(GALLERY_SELECTOR).forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
